import React, { Fragment } from "react";
import styled from "@emotion/styled";
import { SiteData, RouteData } from "react-static";

import Markdown from "../components/markdown";
import Section from "../components/section";
import Seo from "../components/seo";

function Services({ copy, siteData, meta }) {
  return (
    <Fragment>
      <Seo
        url="https://inotherwords.id/services"
        siteTitle={siteData.data.title}
        pageTitle={meta.title}
        description={meta.description}
        image={meta.image}
        siteFBAppID={siteData.data.fbappid}
        userTwitter={siteData.data.twitter}
      />
      <Section title={"Services"}>
        <HorizontalSection>
          {copy.services.data.services.map((service, i) => (
            <ServiceColumn key={i}>
              <h1>{service.title}</h1>
              <Content>
                <Markdown source={service.content} />
              </Content>
            </ServiceColumn>
          ))}
        </HorizontalSection>
      </Section>
    </Fragment>
  );
}

const HorizontalSection = styled.div`
  width: 100%;
  flex: 1;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-around;
  align-items: flex-start;
  margin-bottom: 4rem;
  h1 {
    margin: 1rem 0;
    font-size: 1.2rem;
    font-weight: bold;
    align-self: flex-start;
  }
`;

const ServiceColumn = styled.div`
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  min-width: 212px;
  margin-top: 2rem;
  p {
    align-self: flex-start;
    margin: 1rem 0;
    font-size: 14pt;
    line-height: 1.3;
  }
  @media (max-width: 850px) {
    height: unset;
  }
`;

const Content = styled.div`
  margin-top: 1rem;
  align-self: flex-start;
  width: calc(100% - 2rem);
  max-width: 212px;
  padding: 0 1rem;
  flex: 1;
`;

export default () => (
  <SiteData>
    {siteData => (
      <RouteData>
        {routeData => <Services {...routeData} siteData={siteData} />}
      </RouteData>
    )}
  </SiteData>
);
